import {createTheme} from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';
import blue from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
import blueGrey from "@material-ui/core/colors/blueGrey";


export default createTheme({
    direction: 'rtl',
    palette: {
        primary: {
            main: blue['900'],

        },
        secondary: {
            main: teal['A100'],
        },
        dark: {
            main: grey[300],
            light: '#eff1f7',

        }
    },
});
